var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',[_c('img',{staticClass:"block width-100% card-img-top",attrs:{"loading":"lazy","data-src":_vm.src,"src":_vm.src,"alt":"Image description"}}),_c('noscript',[_c('img',{attrs:{"src":_vm.src,"alt":"Image description"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }